import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { StarRating } from "./StarRating";

const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
};

export const ReviewCard = ({ review, showProductLink = false, productLookup = {} }) => {
  const product = review.product_slug ? productLookup[review.product_slug] : null;
  return (
    <article
      data-testid={`review-card-${review.id}`}
      className="p-6 lg:p-7 border border-[#2A2A2A] rounded-2xl bg-[#0e0e0e] hover:border-[#1565FF]/50 transition-colors flex flex-col gap-4"
    >
      <div className="flex items-center gap-4">
        <div className="w-10 h-10 rounded-full border border-[#2A2A2A] bg-[#171717] grid place-items-center text-white text-sm font-medium">
          {review.author_initials}
        </div>
        <div>
          <div className="text-white text-[14.5px] font-medium tracking-tight">{review.author_name}</div>
          <div className="flex items-center gap-2 mt-0.5">
            {review.verified && (
              <span className="inline-flex items-center gap-1 text-[10px] tracking-widest uppercase font-mono text-[#1565FF]">
                <ShieldCheck size={10} /> Verified researcher
              </span>
            )}
            <span className="text-[11px] font-mono text-[#6E7784]">{fmtDate(review.created_at)}</span>
          </div>
        </div>
      </div>

      <StarRating value={review.rating} size={14} />

      <div>
        <h3 className="text-white text-lg tracking-tight font-medium leading-snug">{review.title}</h3>
        <p className="mt-2 text-[#B7BCC7] text-[13.5px] leading-relaxed">{review.body}</p>
      </div>

      {showProductLink && product && (
        <Link
          to={`/products/${product.slug}`}
          className="mt-1 self-start inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[12px] border border-[#2A2A2A] text-[#B7BCC7] hover:border-[#1565FF] hover:text-white transition-colors"
          data-testid={`review-card-product-link-${review.id}`}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-[#1565FF]" />
          {product.name} · {product.strength}
        </Link>
      )}
    </article>
  );
};
